module.exports = __webpack_public_path__ + "static/bike-barn-4f90874338a512af583291276ef44b89.jpg";